// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 7800 ? "0c7111ee" : chunkId) + "." + {"874":"988e5b49ad1256b1","7800":"f948b55ea910d54b"}[chunkId] + ".js";
};